import(/* webpackMode: "eager", webpackExports: ["Button","Row","Col"] */ "__barrel_optimize__?names=Button,Col,Pagination,Row!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["Row","Col"] */ "__barrel_optimize__?names=Col,Row!=!/app/node_modules/antd/es/index.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@ant-design/icons/es/components/AntdIcon.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-cry.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-dislike.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-heart.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh-unselect.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-laugh.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-like.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-down.svg");
;
import(/* webpackMode: "eager" */ "/app/public/icon/icon-thumb-up.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/boc-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/dan-rang-su.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/nieng-rang-tham-my.svg");
;
import(/* webpackMode: "eager" */ "/app/public/image/trong-rang-implant.svg");
;
import(/* webpackMode: "eager" */ "/app/src/app/blog/review-nha-khoa/page.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/component/blog/blog-clinic-card.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/blog/blog-search.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/blog/blog-suggest.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/blog/review-clinic-intro.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/navigation/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/pagination/index.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/component/tim-phong-kham/contact-section/index.js");
